import { History } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useCourseTime } from '../../contexts/CourseTimeContext';

export function CourseTimeToggle() {
  const { t } = useTranslation();
  const { showAllTime, toggleShowAllTime } = useCourseTime();

  return (
    <button
      onClick={toggleShowAllTime}
      className={`flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium transition-colors ${
        showAllTime
          ? 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400'
          : 'text-muted-foreground hover:text-foreground hover:bg-muted'
      }`}
    >
      <History className="h-3.5 w-3.5 flex-shrink-0" />
      {showAllTime ? t('courseFilter.allTime') : t('courseFilter.upcoming')}
    </button>
  );
}
